module.exports = __webpack_public_path__ + "img/delivered.715417bf.png";